import WarningIcon from "@mui/icons-material/Warning";
import React, { memo } from "react";
import { LMS_TYPE, TUTORIAL_LINK } from "../../../../constants/connectLMS";
import { useTranslation } from "react-i18next";
import { common } from "../../../../utils/common";
import "../ConnectLMSPage.scss";
import KeyField from "../dataField/KeyField";
import SecretField from "../dataField/SecretField";
import UpdateEmails from "../dataField/UpdateEmails";
import UpdateNames from "../dataField/UpdateNames";
import LMSItemActions from "./LMSItemActions";
import LMSItemFunctions from "./LMSItemFunctions";
import PublicKeyField from "../dataField/PublicKeyField";


const LMSItem = memo((props) => {
  const {
    id,
    name,
    keyLti,
    secret,
    status,
    updatedAt,
    lms,
    public_key,
    last_updated,
    version,
    client_id,
  } = props;
  const { t } = useTranslation("translation", {
    keyPrefix: "pages.HomePageOrg.ConnectLMSPage.connectionItem",
  });

  // Full connection passed to the manual LTI 1.3 settings form.
  const connection = {
    id,
    name,
    version,
    client_id,
    platform_url: props.platform_url,
    auth_endpoint: props.auth_endpoint,
    token_endpoint: props.token_endpoint,
    keyset_url: props.keyset_url,
    audience: props.audience,
    private_key: props.private_key,
  };
  

  return (
    <div className="connectLMS-list__item">

      <div className="header">
        <div className="lti-name">{name}</div>
        {lms?.type !== LMS_TYPE.OTHER && (
          <div className="lti-help">
            <WarningIcon />
            <span>
              {t("followThis")}
              <a
                href={TUTORIAL_LINK[lms?.type?.toLocaleUpperCase()]}
                target="_blank"
                rel="noreferrer"
              >
                {t("stepByStep")}
              </a>{" "}
              {t("setUpLti", { type: lms?.name })}
            </span>
          </div>
        )}
      </div>


      <div className="connection-fields">
        <table>
          <tbody>
            {/* only render in LTI v1.1 */}
            { version === 'ltiv1p1' &&(
              <>
                <tr>
                  <th>{t("key")}</th>
                  <KeyField value={keyLti} />
                </tr>

                <tr>
                  <th>{t("secret")}</th>
                  <SecretField value={secret} />
                </tr>
              </>
            )} 

            {/* only render in LTI v1.3 */}
            {
              version==='ltiv1p3' &&(
              <>
                <tr>
                  <th>{t("public_key")}</th>
                  <PublicKeyField value={public_key} />
                </tr>
              </>
            )}
      
            <tr>
              <th>{t("status")}</th>
              <td>{common.capitalizeFirstLetter(status)}</td>
            </tr>
            <tr>
              <th>{t("lastUpdated")}</th>
              <td>{updatedAt}</td>
            </tr>
            

            {/* only render in LTI v1.1 */}
            {
              version==='ltiv1p1' &&(
              <>
                <tr>
                  <th>{t("updateNames.title")}</th>
                  <td>
                    <UpdateNames />
                  </td>
                </tr>


                <tr>
                  <th>{t("updateEmails.title")}</th>
                  <td>
                    <UpdateEmails />
                  </td>
                </tr>
              </>
            )}

            {/* only render in LTI v1.3 */}
            {
              version==='ltiv1p3' &&(
              <>
                <tr>
                  <th>{t("lti_version")}</th>
                  <td>LTI v1.3</td>
                </tr>

                <tr>
                  <th>{t("client_id")}</th>
                  <td>{client_id}</td>
                </tr>
              </>
            )}

            



          </tbody>
        </table>
        <LMSItemActions id={id} status={status} version={version}/>
      </div>
      {/* only render in LTI v1.3 */}
      {
        version ==='ltiv1p3' &&(
          <LMSItemFunctions connection={connection} />
      )}

    </div>
  );
});

export default LMSItem;
